"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = require("react");

var _material = require("@mui/material");

var _LinearProgress = require("../LinearProgress");

var _IconButton = require("../IconButton");

var _TextButton = require("../TextButton");

var _Typography = require("../Typography");

var _Icon = require("../Icon");

var _File = _interopRequireDefault(require("./File"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["disabled", "error", "onDelete", "onDismiss", "readOnly"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledRoot = (0, _material.styled)(_material.Box, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "readOnly" && prop !== "isConfirmingDelete";
  }
})(function (_ref) {
  var theme = _ref.theme,
      readOnly = _ref.readOnly,
      isConfirmingDelete = _ref.isConfirmingDelete;
  return {
    "&:first-of-type": {
      marginTop: readOnly ? "0.5rem" : undefined
    },
    alignItems: "center",
    background: isConfirmingDelete ? theme.palette.primary.light : "white",
    border: "1px solid",
    borderColor: theme.palette.brand.grey.stone,
    display: "flex",
    height: theme.spacing(8),
    justifyContent: "space-between",
    marginTop: "1rem",
    padding: "0rem ".concat(theme.spacing(3))
  };
});
var StyledProgressContaner = (0, _material.styled)(_material.Box, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== "isConfirmingDelete";
  }
})(function (_ref2) {
  var theme = _ref2.theme,
      isConfirmingDelete = _ref2.isConfirmingDelete;
  return {
    flexGrow: 1,
    marginRight: theme.spacing(4),
    opacity: isConfirmingDelete ? "50%" : "100%"
  };
});
var StyledTextButton = (0, _material.styled)(_TextButton.TextButton)(function (_ref3) {
  var theme = _ref3.theme;
  return {
    marginRight: theme.spacing(2)
  };
});

var FileFieldItem = function FileFieldItem(_ref4) {
  var _props$LinearProgress, _props$LinearProgress2, _props$LinearProgress3;

  var _ref4$disabled = _ref4.disabled,
      disabled = _ref4$disabled === void 0 ? false : _ref4$disabled,
      _ref4$error = _ref4.error,
      error = _ref4$error === void 0 ? false : _ref4$error,
      _ref4$onDelete = _ref4.onDelete,
      onDelete = _ref4$onDelete === void 0 ? function () {} : _ref4$onDelete,
      _ref4$onDismiss = _ref4.onDismiss,
      onDismiss = _ref4$onDismiss === void 0 ? function () {} : _ref4$onDismiss,
      _ref4$readOnly = _ref4.readOnly,
      readOnly = _ref4$readOnly === void 0 ? false : _ref4$readOnly,
      props = (0, _objectWithoutProperties2.default)(_ref4, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isConfirmingDelete = _useState2[0],
      setIsConfirmingDelete = _useState2[1];

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledRoot, {
    isConfirmingDelete: isConfirmingDelete,
    readOnly: readOnly,
    children: [!error && ((_props$LinearProgress = props.LinearProgressProps) === null || _props$LinearProgress === void 0 ? void 0 : _props$LinearProgress.value) !== 100 && !readOnly && /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledProgressContaner, {
      isConfirmingDelete: isConfirmingDelete,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.Typography, {
        color: "primary",
        gutterBottom: true,
        variant: "body2",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
          children: props.fileName
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LinearProgress.LinearProgress, _objectSpread({}, props.LinearProgressProps)), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
        mt: 1
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.Typography, {
        color: "textSecondary",
        variant: "body3",
        children: props.helperText
      })]
    }), !error && (((_props$LinearProgress2 = props.LinearProgressProps) === null || _props$LinearProgress2 === void 0 ? void 0 : _props$LinearProgress2.value) === 100 || readOnly) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_File.default, _objectSpread(_objectSpread({}, props), {}, {
      isConfirmingDelete: isConfirmingDelete
    })), error && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
      alignItems: "center",
      display: "flex",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        color: "error",
        iconName: "exclamation-triangle",
        mr: 2
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
        display: "flex",
        flexDirection: "column",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.Typography, {
          color: "textSecondary",
          variant: "body2",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
            children: props.fileName
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.Typography, {
          color: "textSecondary",
          variant: "body3",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
            children: props.helperText
          })
        })]
      })]
    }), error && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.IconButton, {
      "aria-label": props.labels.dismiss,
      borderless: true,
      iconName: "times",
      onClick: onDismiss,
      size: "large"
    }), !error && isConfirmingDelete && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
      alignItems: "center",
      display: "flex",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
        mr: 7
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.Typography, {
        color: "textSecondary",
        variant: "body2",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("b", {
          children: props.labels.deletePrompt
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
        mr: 3
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextButton.TextButton, {
        label: props.labels.deleteConfirm,
        onClick: onDelete
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
        mr: 3
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextButton.TextButton, {
        label: props.labels.cancel,
        onClick: function onClick() {
          return setIsConfirmingDelete(false);
        },
        variant: "outlined"
      })]
    }), !error && !isConfirmingDelete && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
      flexShrink: 0,
      children: [(readOnly || ((_props$LinearProgress3 = props.LinearProgressProps) === null || _props$LinearProgress3 === void 0 ? void 0 : _props$LinearProgress3.value) === 100) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [props.viewHref && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTextButton, {
          component: "a",
          href: props.viewHref,
          iconLeft: "external-link-alt",
          label: props.labels.viewDocument,
          target: "_blank",
          variant: "outlined"
        }), (props.onDownload || props.downloadHref) && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTextButton, {
          component: props.onDownload ? "button" : "a",
          download: props.fileName,
          href: props.onDownload ? undefined : props.downloadHref,
          iconLeft: "download",
          label: props.labels.download,
          onClick: props.onDownload,
          variant: "outlined"
        })]
      }), !readOnly && /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.IconButton, {
        "aria-label": props.labels.delete,
        borderless: true,
        disabled: disabled,
        iconName: "trash-alt",
        onClick: function onClick() {
          return setIsConfirmingDelete(true);
        },
        size: "large"
      })]
    })]
  });
};

var _default = FileFieldItem;
exports.default = _default;